module.exports = __webpack_public_path__ + "img/mobilereportforrepair3.9dd0ee5c.png";